import api from './index'
import { axios, pureAxios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function code () {
  return axios({
    url: '/code',
    method: 'get',
  })
}

export function forget_pwd (parameter) {
  return axios({
    url: api.gateway_system+'user/forget_pwd',
    method: 'post',
    data: parameter
  })
}
export function login (parameter) {
  return axios({
    url: api.gateway_auth+'login',
    method: 'post',
    data: parameter
  })
}

export function getSmsCaptcha (parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return axios({
    url: api.gateway_system+'user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout (token) {
  return axios({
    url: api.gateway_auth+'logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': token
    }
  })
}

export function imgcode () {
  return pureAxios({
    url: '/code',
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step (parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter
  })
}

// 获取验证图片  以及token
// export function getCaptcha (data) {
//   return axios({
//     url: api.gateway_auth+'captcha/get',
//     method: 'post',
//     data
//   })
// }

// 滑动或者点选验证
export function captchaCheck (data) {
  return axios({
    url: api.gateway_auth+'captcha/check',
    method: 'post',
    data
  })
}
// 获取app最新安装包二维码
export function last_app_qr(parameter) {
  return axios({
    url: '/file/file/last_app_qr',
    method: 'get',
    params: parameter
  })
}
